import { observer } from 'mobx-react-lite';
import { useState } from 'react';

import JobCardPdfTypeDialog from '~hooks/useJobCardPdf/JobCardPdfTypeDialog';
import { JobCardPdfRecipientType } from '~hooks/useJobCardPdf/models';
import { useStores } from '~store';

import DispatchTriggerButton from './DispatchTriggerButton';
import getDownloadJobCardPdfsContent from './downloadJobCardPdfsContent';

interface DownloadJobCardPdfsButtonProps {
  isDisabled?: boolean;
  onRecipientTypeSelect: (recipientType: JobCardPdfRecipientType) => Promise<void>;
  placement: 'bulkActionsBar' | 'exportMenu';
}

const DownloadJobCardPdfsButton = observer(
  ({ isDisabled, onRecipientTypeSelect, placement }: DownloadJobCardPdfsButtonProps) => {
    const { userStore } = useStores();
    const { canEditJob } = userStore.getPermissions();
    const [isJobCardPdfTypeDialogOpen, setIsJobCardPdfTypeDialogOpen] = useState(false);
    const [isRequestingRender, setIsRequestingRender] = useState(false);

    if (!canEditJob) {
      return null;
    }

    const { icon, label } = getDownloadJobCardPdfsContent();

    const openJobCardPdfTypeDialog = () => setIsJobCardPdfTypeDialogOpen(true);

    const handleJobCardPdfTypeSelect = async (recipientType: JobCardPdfRecipientType) => {
      setIsJobCardPdfTypeDialogOpen(false);
      setIsRequestingRender(true);

      try {
        await onRecipientTypeSelect(recipientType);
      } finally {
        setIsRequestingRender(false);
      }
    };

    return (
      <>
        <DispatchTriggerButton
          data-test-id="download-job-card-pdfs-button"
          disabled={isDisabled}
          loading={isRequestingRender}
          onClick={openJobCardPdfTypeDialog}
          placement={placement}
          startIcon={icon}
        >
          {label}
        </DispatchTriggerButton>

        <JobCardPdfTypeDialog
          isOpen={isJobCardPdfTypeDialogOpen}
          onClose={() => setIsJobCardPdfTypeDialogOpen(false)}
          onSelect={handleJobCardPdfTypeSelect}
        />
      </>
    );
  },
);

export default DownloadJobCardPdfsButton;
